var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-imgcrop",style:(_vm.styles),on:{"click":_vm.onNavigation}},[_c('img',{attrs:{"src":_vm.detail.images[0].url,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }